// extracted by mini-css-extract-plugin
module.exports = {"root":"footer_root__rLNQa","menu":"footer_menu__12p75","signup":"footer_signup__WZDDN","copyRight":"footer_copyRight__zUsjx"};